import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { AdditionalVisitorComponent } from './component/additional-visitor.component';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    AdditionalVisitorComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,

    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class AdditionalVisitorModule { }
